<template>
  <p class="page-title">
    <svg class="icon" v-if="icon">
      <use :xlink:href="icon"></use>
    </svg><span v-if="typeof title === 'string'">{{title}}</span>
    <el-breadcrumb v-else separator-class="el-icon-arrow-right">
      <template v-for="(item, index) in title">
        <el-breadcrumb-item v-if="item.path && index !== title.length - 1" :class="item.path ? '' : 'default'" :to="{ path: item.path }" :key="index">{{item.name}}</el-breadcrumb-item>
        <el-breadcrumb-item v-else  :class="item.path && index ? '' : 'default'" :key="index">{{item.name}}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </p>
</template>

<script>

export default {
  name: 'PageTitle',
  props: {
    icon: {
      type: String
    },
    title: {
      type: [String, Array],
      default: () => ''
    }
  }
}
</script>

<style lang="stylus" scope>
@import '~styl/mixins'
.page-title
  overflow hidden
  line-height: .4rem
  font-size: .28rem
  color: color-dark-black
  .icon
    float left
    position relative
    margin .04rem .1rem 0.06rem 0
  .el-breadcrumb
    float left
    display inline-block
    font-size: .28rem
    color: color-dark-black
    line-height normal
  .default
    &:last-child .el-breadcrumb__item__inner:hover
      color: #97a8be
      cursor: text
    .el-breadcrumb__item__inner:hover
      color: #48576a
      cursor: text
</style>



// WEBPACK FOOTER //
// app/components/PageTitle/index.vue